import { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyTitle } from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';

const SectionFeedback = ({ icon, title, text, actions, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('p-4', className);

	// Render
	return (
		<Empty className={rootClassName}>
			<EmptyContent>
				{icon && (
					<EmptyMedia className='[&_svg]:size-4'>
						<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
					</EmptyMedia>
				)}
				{title && <EmptyTitle>{title}</EmptyTitle>}
				{text && <EmptyDescription>{text}</EmptyDescription>}
			</EmptyContent>
			{actions && <EmptyActions className='py-4'>{actions}</EmptyActions>}
		</Empty>
	);
};
export { SectionFeedback };
